import { PropsWithChildren } from 'react';

interface LiveTvBadgeProps extends PropsWithChildren {
  background: string;
  color: string;
  onClick?: () => void;
  asButton?: boolean;
}

export default function LiveTvBadge({ background, color, children, onClick, asButton = false }: LiveTvBadgeProps) {
  const sharedStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 12px',
    borderRadius: 999,
    background,
    color,
    fontSize: 13,
    fontWeight: 700,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    border: 'none',
  };

  if (asButton) {
    return (
      <button
        type="button"
        onClick={onClick}
        style={{
          ...sharedStyle,
          cursor: 'pointer',
          minHeight: 44,
        }}>
        {children}
      </button>
    );
  }

  return <span style={sharedStyle}>{children}</span>;
}
